export enum TypePdf {
  FACTURE_EXPEDITION = "FACTURE_EXPEDITION",
  AVOIR_CLIENT = "AVOIR_CLIENT",
  COMMANDE_FOURNISSEUR = "COMMANDE_FOURNISSEUR",
  SPECIFICATION = "SPECIFICATION",
  DOSSIER_PRODUCTION = "DOSSIER_PRODUCTION",
  FICHE_PALETTE = "FICHE_PALETTE",
  /**
   * **L'étiquette d'un échantillon d'essai** — 100 × 50 mm, format PRODUIT.
   *
   * 🔴 **Elle réutilisait `FICHE_PALETTE`, et c'était le mauvais objet** : une étiquette logistique
   * (REF / CONTENU / QUANTITÉ UC / QUANTITÉ COLIS / POIDS BRUT) sur laquelle **six cases sur huit**
   * affichaient « – », parce qu'un échantillon n'a ni colis, ni poids brut, ni contenu.
   */
  ETIQ_ESSAI = "ETIQ_ESSAI",
  ETIQ_CARTON = "ETIQ_CARTON",
  ETIQ_CARTON_EAN13 = "ETIQ_CARTON_EAN13",
  /** `ETIQ_CARTON_EAN13` réduite à la dénomination et à l'EAN-13 : ni EAN UVC, ni DDM / lot, ni GS1-128. */
  ETIQ_CARTON_EAN13_SIMPLE = "ETIQ_CARTON_EAN13_SIMPLE",
  ETIQ_BARQUETTE = "ETIQ_BARQUETTE",
  BL_CLIENT = "BL_CLIENT",
  FICHE_PALETTE_EXPEDITION = "FICHE_PALETTE_EXPEDITION",
  CONFIRMATION_COMMANDE_CLIENT = "CONFIRMATION_COMMANDE_CLIENT",
  SUIVI_PRODUCTION = "SUIVI_PRODUCTION",
  BON_TRANSFERT = "BON_TRANSFERT",
  DOSSIER_PRODUCTION_V2 = "DOSSIER_PRODUCTION_V2",
  FICHE_NC = "FICHE_NC",
  /** Rapport de non-conformité — courrier A4 complet (dossier qualité, envoi externe). */
  RAPPORT_NC = "RAPPORT_NC",
  /** Rapport générique fabriqué à la demande par l'assistant Justy (bloc UI `pdf_report`). */
  RAPPORT_ASSISTANT = "RAPPORT_ASSISTANT",
  RAPPORT_QUALITE = "RAPPORT_QUALITE",
  /**
   * La fiche technique d'une recette du module de développement.
   *
   * ⚠️ **Distincte de `SPECIFICATION`, et ce n'est pas un doublon** : celle-ci imprime « FICHE DE
   * SPECIFICATIONS » avec la nomenclature, les codes article et les visas — un document d'atelier. La
   * fiche technique est ce qu'on envoie à un client : liste d'ingrédients, allergènes, déclaration
   * nutritionnelle.
   */
  FICHE_TECHNIQUE = "FICHE_TECHNIQUE",
  /**
   * La **fiche allergènes client** : les 14 allergènes de l'annexe II pour une sélection de la matrice
   * allergènes (#11). Payload composé par back-metier, sans verdict.
   */
  FICHE_ALLERGENES = "FICHE_ALLERGENES",
}
